import { Link } from 'react-router';
import { useStripeAccounts } from '../api/stripeAccounts';

function formatUpdated(at: string | null, by: string | null): string {
  if (!at) return '—';
  const date = new Date(at).toLocaleDateString();
  // updatedBy is the user id, not display name. We don't fetch the granter's
  // displayName here to avoid an extra round-trip; "by CLI" reflects a CLI
  // rotation, anything else is "by an Owner".
  return by === null ? `${date} (CLI)` : date;
}

export function StripeAccountsList() {
  const accounts = useStripeAccounts();

  return (
    <div className="page">
      <div className="page-head">
        <h1>Stripe accounts</h1>
        <div className="page-actions">
          <Link to="/stripe-accounts/new" className="btn btn-primary">
            New account
          </Link>
        </div>
      </div>

      {accounts.isPending && <div className="loading">Loading…</div>}
      {accounts.isError && <div className="error">Could not load Stripe accounts.</div>}
      {accounts.data && accounts.data.length === 0 && (
        <div className="empty">No Stripe accounts yet.</div>
      )}
      {accounts.data && accounts.data.length > 0 && (
        <div className="card">
          <table className="tbl">
            <thead>
              <tr>
                <th>Display name</th>
                <th>Label</th>
                <th>Mode</th>
                <th>Secret key</th>
                <th>Webhook secret</th>
                <th aria-label="Edit" />
              </tr>
            </thead>
            <tbody>
              {accounts.data.map((a) => (
                <tr key={a.id}>
                  <td>{a.displayName}</td>
                  <td><span className="micro">{a.label}</span></td>
                  <td>
                    {a.stripeMode === null ? (
                      <span className="pill pill-draft">unset</span>
                    ) : a.stripeMode === 'live' ? (
                      <span className="pill pill-live">live</span>
                    ) : (
                      <span className="pill pill-upcoming">test</span>
                    )}
                  </td>
                  <td>
                    {a.secretKey.set ? (
                      <span>
                        …{a.secretKey.last4 ?? '????'}{' '}
                        <span className="micro">
                          updated {formatUpdated(a.secretKey.updatedAt, a.secretKey.updatedBy)}
                        </span>
                      </span>
                    ) : (
                      <span className="pill pill-ended">not set</span>
                    )}
                  </td>
                  <td>
                    {a.webhookSecret.set ? (
                      <span>
                        …{a.webhookSecret.last4 ?? '????'}{' '}
                        <span className="micro">
                          updated{' '}
                          {formatUpdated(a.webhookSecret.updatedAt, a.webhookSecret.updatedBy)}
                        </span>
                      </span>
                    ) : (
                      <span className="pill pill-ended">not set</span>
                    )}
                  </td>
                  <td>
                    <Link to={`/stripe-accounts/${a.id}/edit`} className="btn btn-ghost btn-sm">
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
